var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttitude(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8C9.42826 8 10.3185 7.63125 10.9749 6.97487C11.6313 6.3185 12 5.42826 12 4.5C12 3.57174 11.6313 2.6815 10.9749 2.02513C10.3185 1.36875 9.42826 1 8.5 1C7.57174 1 6.6815 1.36875 6.02513 2.02513C5.36875 2.6815 5 3.57174 5 4.5C5 5.42826 5.36875 6.3185 6.02513 6.97487C6.6815 7.63125 7.57174 8 8.5 8ZM4.25 9C3.78587 9 3.34075 9.18437 3.01256 9.51256C2.68437 9.84075 2.5 10.2859 2.5 10.75V11C2.5 12.1965 3.2615 13.2085 4.3425 13.8965C5.4295 14.5885 6.901 15 8.5 15C10.099 15 11.57 14.5885 12.6575 13.8965C13.7385 13.2085 14.5 12.1965 14.5 11V10.75C14.5 10.2859 14.3156 9.84075 13.9874 9.51256C13.6592 9.18437 13.2141 9 12.75 9H4.25Z",
    fill: "#FFDD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttitude);
export default __webpack_public_path__ + "static/media/attitude.24111a3f3f2139f2253b6a63408a603b.svg";
export { ForwardRef as ReactComponent };